const GEN_SHARELINK_WINDOW_JS_URI = 'scripts/sharelink_window_4ai.bdf56a60.js';
const GEN_PWA_INSALL_JS_URI = 'scripts/pwa_install_4ai.8bd95f63.js';
const GEN_ONE_SUBMIT_JS_URI = 'scripts/one_submit_4ai.ea419889.js';
const GEN_CTA_CLICK_PHONE_JS_URI = 'scripts/cta_click_phone.c5144da0.js';
const GEN_SCROLL_CLASS_JS_URI = 'scripts/scroll_class.1dfd230c.js';
const GEN_SLIDER_JS_URI = 'scripts/slider.3560f2f1.js';
const GEN_TABS_JS_URI = 'scripts/tabs.3b3f6006.js';
const GEN_CONTRAST_JS_URI = 'scripts/contrast.7c9fb2e7.js';

const themePath = main_scripts.dist_path;

window.collections = {};

const SCRIPTS = [
    {
        'url' : GEN_SHARELINK_WINDOW_JS_URI,
        'sel' : '.share-links a, .share-links .copy-link',
        'col' : 'sharelinks'
    },
    {
        'url' : GEN_PWA_INSALL_JS_URI,
        'sel' : '.pwa-install-btn',
        'col' : 'addBtn'
    },
    {
        'url' : GEN_ONE_SUBMIT_JS_URI,
        'sel' : 'form',
        'col' : 'forms'
    },
    {
        'url' : GEN_CTA_CLICK_PHONE_JS_URI,
        'sel' : 'a[href^="tel:"]',
        'col' : 'clickPhone'
    },
    {
        'url' : GEN_SCROLL_CLASS_JS_URI,
        'sel' : 'header',
        'col' : 'scrollClass'
    },
    {
        'url' : GEN_SLIDER_JS_URI,
        'sel' : '.swipe-container',
        'col' : 'Slider'
    },
    {
        'url' : GEN_TABS_JS_URI,
        'sel' : '.tabs-wrapper',
        'col' : 'tabs'
    },
    {
        'url' : GEN_CONTRAST_JS_URI,
        'sel' : '#contrast-btn',
        'col' : 'contrastBtn'
    }
];

let selectors = [];
for(let script of SCRIPTS ) {
    selectors.push(script.sel);
}
const obj_present = Array.from(document.querySelectorAll( selectors.join(',') ) );

for(let script of SCRIPTS ) {
    if(Array.from) {
        collections[script.col] = Array.from(document.querySelectorAll(script.sel));
        if(collections[script.col].length > 0) {
            if(script.lazy) {
                let encours = false,
                    observer = new IntersectionObserver(function(entries) {
                    for (let j = 0, lg = entries.length; j < lg; j++) {
                        if (entries[j].intersectionRatio <= 0 || encours) return;
                        encours = true;
                        new loadExt([themePath+script.url]);
                        for (let k = 0, lgt = entries.length; k < lgt; k++) {
                            observer.unobserve(entries[k].target);
                        }
                    }
                }, obsOptions);

                for (let i = 0, l = collections[script.col].length; i < l; i++) {
                    observer.observe(collections[script.col][i]);
                }

            } else {
                new loadExt([themePath+script.url]);
            }
        }
    }
}

// FONCTIONS JS SAMSIC
(function() {

    // CHECK if safari browser specifique pour les sliders
    var isIos = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if(isIos) {
        document.body.classList.add('safari');
    }


})();
